import type { SettingsChange } from '../utils/settings-diff.util';

type SettingsChangesTableProps = {
  changes: SettingsChange[];
  /** Mudanças registradas além das exibidas. */
  hiddenChanges?: number;
};

/** O "de/para" de uma alteração: usado na confirmação antes de salvar e no histórico. */
export function SettingsChangesTable({
  changes,
  hiddenChanges = 0,
}: SettingsChangesTableProps) {
  return (
    <div className='overflow-hidden rounded-lg border border-alba-gray-200'>
      <table className='w-full table-fixed text-left text-sm'>
        <thead className='bg-alba-gray-200/50 text-xs text-alba-gray-600'>
          <tr>
            <th scope='col' className='w-5/12 px-3 py-2 font-medium'>
              Campo
            </th>
            <th scope='col' className='px-3 py-2 font-medium'>
              De
            </th>
            <th scope='col' className='px-3 py-2 font-medium'>
              Para
            </th>
          </tr>
        </thead>
        <tbody className='divide-y divide-alba-gray-200'>
          {changes.map((change, index) => (
            <tr key={`${change.label}-${index}`}>
              <td className='break-words px-3 py-2 text-alba-gray-700'>
                {change.label}
              </td>
              <td className='break-words px-3 py-2 text-alba-gray-500 line-through'>
                {change.before ?? '—'}
              </td>
              <td className='break-words px-3 py-2 font-medium text-alba-black-500'>
                {change.after ?? '—'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {hiddenChanges > 0 && (
        <p className='border-t border-alba-gray-200 px-3 py-2 text-xs text-alba-gray-500'>
          E mais {hiddenChanges} alteração(ões) registrada(s) e não exibida(s).
        </p>
      )}
    </div>
  );
}
